import { createSupportingModule, DEFAULT_PRODUCT_VALUE, DEFAULT_SORT, SECTION_TYPES } from './shared/configs';

enum SECTION_ENUM {
  US = '米国',
  CHINA = '中国',
  CHINA_NEWSLETTER = '中国洞察',
  ASIA_AND_OCEANIA = 'アジア・オセアニア',
  EUROPE_AND_RUSSIA = '欧州・ロシア',
  MIDDLE_EAST_AND_AFRICA = '中東・アフリカ'
}
const {
  WORLD,
  USA,
  CHINA,
  CHINA_NEWSLETTER,
  ASIA_AND_OCEANIA,
  EUROPE_AND_RUSSIA,
  MIDDLE_EAST_AND_AFRICA,
  ELECTION_2024
} = SECTION_TYPES;

const baseQuery = {
  query: {
    and: [
      { terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } },
      {
        terms: {
          key: 'SectionType',
          value: [
            WORLD,
            USA,
            CHINA,
            CHINA_NEWSLETTER,
            ASIA_AND_OCEANIA,
            EUROPE_AND_RUSSIA,
            MIDDLE_EAST_AND_AFRICA,
            ELECTION_2024
          ]
        }
      }
    ]
  },
  ...DEFAULT_SORT
};

const US_QUERY = createSupportingModule([USA]);
const CHINA_QUERY = createSupportingModule([CHINA]);
const CHINA_NEWSLETTER_QUERY = createSupportingModule([CHINA_NEWSLETTER]);
const ASIA_AND_OCEANIA_QUERY = createSupportingModule([ASIA_AND_OCEANIA]);
const EUROPE_AND_RUSSIA_QUERY = createSupportingModule([EUROPE_AND_RUSSIA]);
const MIDDLE_EAST_AND_AFRICA_QUERY = createSupportingModule([MIDDLE_EAST_AND_AFRICA]);

export {
  SECTION_ENUM,
  baseQuery as WORLD,
  US_QUERY,
  CHINA_QUERY,
  CHINA_NEWSLETTER_QUERY,
  ASIA_AND_OCEANIA_QUERY,
  EUROPE_AND_RUSSIA_QUERY,
  MIDDLE_EAST_AND_AFRICA_QUERY
};
